module.exports = __webpack_public_path__ + "img/Error.c63279b3.svg";